import en, { common as commonEnglish } from './en'
import es, { common as commonSpanish } from './es'

export default { en, es, commonEnglish, commonSpanish }
